import PropTypes from 'prop-types';
import { useState } from 'react';
import ReactModal from 'react-modal';

import CUSTOM_STYLES from '../utils/modalStyle';

import { PrimaryButton, SecondaryButton } from './Buttons/Buttons';
import styles from './GenericModalV2.module.scss';

function ConfirmationModal({
  children,
  isOpen = true,
  mainText = '',
  modalLabel,
  onClickContinue,
  onClickBack,
  backBtnText = 'Ακυρο',
  continueBtnText = 'Συνέχεια',
  modalClose,
  shouldCloseOnOverlayClick = true,
}) {
  const [_isModalOpen, setIsModalOpen] = useState(isOpen);
  const _onClickContinue = onClickContinue || closeModal;
  const _onClickBack = onClickBack || closeModal;
  function closeModal() {
    setIsModalOpen(false);
  }

  return (
    <ReactModal
      isOpen={_isModalOpen}
      onRequestClose={modalClose}
      style={CUSTOM_STYLES}
      contentLabel={modalLabel}
      ariaHideApp={false}
      className={styles.modalContent}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
    >
      <div className={styles.modalContainer}>
        <main>{children || <p className={styles.text}>{mainText}</p>}</main>
        <footer className={styles.footer}>
          <SecondaryButton onClick={_onClickBack}>{backBtnText}</SecondaryButton>
          <PrimaryButton onClick={_onClickContinue} data-cy="modal-accept-btn">
            {continueBtnText}
          </PrimaryButton>
        </footer>
      </div>
    </ReactModal>
  );
}

ConfirmationModal.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  mainText: PropTypes.string,
  modalLabel: PropTypes.string.isRequired,
  onClickContinue: PropTypes.func,
  backBtnText: PropTypes.string,
  continueBtnText: PropTypes.string,
};

export default ConfirmationModal;
